import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';
import UserMenu from '../common/components/Header/UserMenu';

const DownloadHeader = () => {
  return (
    <header className="h-16 flex items-center justify-between px-6 bg-indigo-700 shadow-md sticky top-0 z-30">
      {/* トップページに戻るボタン */}
      <Link
        to="/"
        className="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors"
      >
        <FiHome className="w-5 h-5" />
        <span className="hidden sm:inline">トップページ</span>
      </Link>
      
      <UserMenu />
    </header>
  );
};

export default DownloadHeader; 